import { Box, Dialog, IconButton, Slide, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import { TransitionProps } from "@mui/material/transitions";
import { isBrowser, isTablet } from "react-device-detect";
import { icon, isSeller, SELLER, WEBSITE_PATH, windowPostMessage } from "../../common/common";
import BookmarkedPostsTab from "./bookmarkedPosts";
import MyPostsTab from "./myPosts";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface SharePostProps {
  senderID: string;
  onBookmarkedPostClick: any;
  onMyPostClick: any;
  ucnum?: string;
}

const SharePost = ({ senderID, onBookmarkedPostClick, onMyPostClick, ucnum }: SharePostProps, ref: any) => {
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [sharePostDialogOpen, setSharePostDialogOpen] = useState<boolean>(false);
  const [isSecondTabClicked, setIsSecondTabClicked] = useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    openShareDialog: () => {
      setSharePostDialogOpen(true);
    },
    closeShareDialog: () => {
      handleSharePostDialogClose();
    },
  }));

  const handleSharePostTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    newValue === 1 && setIsSecondTabClicked(true);
  };
  const handleSharePostDialogClose = () => setSharePostDialogOpen(false);

  return (
    <Dialog id="share-post-dialog" className={`${isTablet ? "bg-true-white" : ""} ${!isSeller() || isBrowser ? "post-dialog" : ""}`} fullScreen open={sharePostDialogOpen} onClose={handleSharePostDialogClose} TransitionComponent={Transition} PaperProps={{ sx: { boxShadow: "none" } }} sx={{ pl: isBrowser ? 2 : 0, pr: isBrowser ? 1 : 0, pt: isBrowser ? 1 : 0 }} hideBackdrop>
      <Box className="share-post-divider"></Box>
      <Box className="bg-true-white w-per-100 pos-rel post-gutter">
        <Toolbar className="post-toolbar flex-space-between flex" sx={{ p: "0px !important" }}>
          <Box className="box-48"></Box>
          <Typography className="inboxHeaderTitle" variant="h6" sx={{ textAlign: "center" }}>
            Share post
          </Typography>
          <IconButton
            className="box-48"
            onClick={() => {
              !isBrowser && windowPostMessage({ type: "historyBack" }, WEBSITE_PATH);
              handleSharePostDialogClose();
            }}
          >
            {icon({ iconName: "close" })}
          </IconButton>
        </Toolbar>
        <Box sx={{ position: "relative", height: `${isTablet ? "calc(100vh - 162px)" : isBrowser ? "calc(100vh - 137px)" : "calc(100vh - 120px)"}` }}>
          {!SELLER ? (
            <Box className="post-tab-container mar-t-4">
              <Tabs value={tabIndex} onChange={handleSharePostTabChange} sx={{ display: "inline-flex !important" }}>
                <Tab label="My posts" />
                <Tab label="Bookmarks" />
              </Tabs>
            </Box>
          ) : (
            ""
          )}

          <Box className={`${SELLER ? "mar-t-16" : ""} ${tabIndex === 0 || SELLER ? "" : "mdc-soft-hide"}`}>
            <MyPostsTab senderID={senderID} onMyPostClick={onMyPostClick} ucnum={ucnum} />
          </Box>

          {!SELLER && isSecondTabClicked ? (
            <Box className={`${tabIndex === 1 ? "" : "mdc-soft-hide"}`}>
              <BookmarkedPostsTab />
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default forwardRef(SharePost);
